<template>
    <div>
        <e-dialog
                dialogTitle="易派客提醒您"
                :centerDialogVisible="selectOnlyVisible"
                @resetPopupData="resetPopupData"
                @submitPopupData="resetPopupData"
                :popupWidth="'420px'">
            <div>只能选择一家评价机构进行相应的操作</div>
        </e-dialog>
    </div>

</template>

<script>
    import eDialog from "@/modules/projectA/components/common/e-dialog.vue";
    export default {
        name: "selectOnlyDialog",
        components:{eDialog},
        props:{
            selectOnlyVisible:Boolean
        },
        methods:{
            resetPopupData(){
                this.$emit('closeDialog');
            },
        },
    }
</script>

<style scoped lang="scss">

</style>